import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/images/mydocit.jpeg'
import { toast } from 'react-toastify';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import api from '../utils/axios';


const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const toggleVisibility = () => {
    setVisibility((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/auth/login', {
        email,
        password
      });

      const { idToken, uid, email: userEmail, displayName, role } = response.data;

      // Store the token and user info
      localStorage.setItem('token', idToken);
      localStorage.setItem('user', JSON.stringify({
        uid,
        email: userEmail,
        displayName,
        role
      }));

      // Update auth context
      login();

      // Redirect to dashboard
      navigate('/dashboard');
      toast.success('Login successful!');
    } catch (error) {
      console.error('Error during login:', error);
      const errorMessage = error.response?.data?.error || 'An error occurred during login. Please try again.';
      toast.error(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background: 'linear-gradient(180deg, #87D601 0%, #002F7F 74%, #002D7E 100%)',
      }}
    >
      <main className="bg-white w-full max-w-md p-8 rounded-lg shadow-2xl">
        <section>
          <img src={logo} alt="Logo" className="w-48 mx-auto mb-6" />
  
          <form className="flex flex-col" onSubmit={handleSubmit} noValidate method="POST">
            <div className="mb-4">
              <label htmlFor="email" className="block mb-1 text-primary">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="input input-bordered w-full"
                disabled={loading}
              />
            </div>
  
            <div className="mb-4">
              <label htmlFor="password" className="block mb-1 text-primary">Password</label>
              <div className="relative">
                <input
                  type={visibility ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="input input-bordered w-full pr-10"
                  disabled={loading}
                />
                <button
                  type="button"
                  onClick={toggleVisibility}
                  className="absolute right-4 top-4 text-gray-600"
                >
                  {visibility ? <MdVisibilityOff /> : <MdVisibility />}
                </button>
              </div>
            </div>
  
            <div className="flex justify-end mb-4">
              <Link to="/forgot-password" className="text-primary hover:underline">
                Forgot Password?
              </Link>
            </div>
  
            <button
              className="bg-primary hover:bg-slatext-slate-500 text-white font-bold py-2 rounded shadow-lg hover:shadow-xl transition duration-200"
              type="submit"
              disabled={loading}
            >
              {loading ? "Logging In..." : "Login"}
            </button>
          </form>
        </section>
  
        <p className="text-center text-xs text-gray-500 mt-6">
          My DocIT Management System &copy; {new Date().getFullYear()}
        </p>
      </main>
    </div>
  );
  
};

export default Login;
